import { render, staticRenderFns } from "./ImageControls.vue?vue&type=template&id=b32bbc96&scoped=true"
import script from "./ImageControls.vue?vue&type=script&lang=js"
export * from "./ImageControls.vue?vue&type=script&lang=js"
import style0 from "./ImageControls.vue?vue&type=style&index=0&id=b32bbc96&prod&lang=scss&scoped=true"
import style1 from "./ImageControls.vue?vue&type=style&index=1&id=b32bbc96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32bbc96",
  null
  
)

export default component.exports